/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { sendSegment, subscribeSegment } from './common-websocket-topic-url-constants';
import {
  alertNotificationPingSegment,
  alertNotificationSegment,
  selectItemsSegment,
  selectItemsUpdatedSegment
} from './administration-websocket-topic-url-constants';

export const sendAlertNotificationPingTopicUrl = (entityType: any, entityUuid: any) => `/${sendSegment}/${alertNotificationSegment}/${alertNotificationPingSegment}/${entityType}/${entityUuid}`;
export const alertNotificationEndpointTopicUrl = (entityType: any, entityUuid: any) => `/${subscribeSegment}/${alertNotificationSegment}/${entityType}/${entityUuid}`;

export const selectItemsUpdatedEndpointTopicUrl = (locale: any) => `/${subscribeSegment}/${selectItemsSegment}/${locale}/${selectItemsUpdatedSegment}`;

